// imageUploadSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { uploadImageAPI } from '../services/api';

export const uploadImage = createAsyncThunk('image/upload', async (file, { rejectWithValue }) => {
    try {
        const response = await uploadImageAPI(file);
        return response.data;
    } catch (error) {
        // Return more detailed error information
        const errorMessage = error.response?.data?.message || 
                           error.response?.data?.error || 
                           error.message || 
                           'Upload failed';
        return rejectWithValue({ message: errorMessage, originalError: error });
    }
});

const imageUploadSlice = createSlice({
    name: 'imageUpload',
    initialState: {
        imageUrl: '',
        status: 'idle',
        error: null,
        uploadProgress: 0,
    },
    reducers: {
        resetImage: (state) => {
            state.imageUrl = '';
            state.status = 'idle';
            state.error = null;
            state.uploadProgress = 0;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadImage.pending, (state) => {
                state.status = 'loading';
                state.uploadProgress = 0;
            })
            .addCase(uploadImage.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.imageUrl = action.payload.fileUrl;
                state.uploadProgress = 100;
            })
            .addCase(uploadImage.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                state.uploadProgress = 0;
            });
    },
});

export const { resetImage } = imageUploadSlice.actions;
export default imageUploadSlice.reducer;